import { render, staticRenderFns } from "./ChecklistCard.vue?vue&type=template&id=15bb7134&"
import script from "./ChecklistCard.vue?vue&type=script&lang=js&"
export * from "./ChecklistCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports